import { Link } from "react-router-dom";
import { SITE } from "../../lib/site";

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="relative bg-[var(--bg-surface)] border-t border-white/10 px-6 md:px-12 lg:px-24 pt-16 pb-10"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <span className="w-10 h-10 rounded-full bg-gradient-to-br from-[#E9C766] via-[#D4AF37] to-[#8a6618] flex items-center justify-center text-black font-bold">
              AS
            </span>
            <div>
              <div className="text-white font-semibold">DJ AS Animation</div>
              <div className="text-xs uppercase tracking-[0.28em] text-zinc-400">
                Adrien Sebert
              </div>
            </div>
          </div>
          <p className="mt-5 text-sm text-zinc-400 max-w-md leading-relaxed">
            DJ professionnel basé à <span className="text-white">La Chapelle-près-Sées (61500)</span>.
            Mariages, anniversaires, soirées privées, événements d'entreprise et événements publics —
            partout en Normandie et dans le Grand Ouest.
          </p>
          <div className="mt-6 flex flex-wrap gap-2">
            {SITE.areas.map((a) => (
              <span
                key={a}
                className="text-[11px] tracking-[0.18em] uppercase text-zinc-300 px-3 py-1.5 rounded-full border border-white/10 bg-white/[0.02]"
              >
                {a}
              </span>
            ))}
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.22em] text-zinc-500 mb-4">
            Navigation
          </div>
          <ul className="space-y-3 text-sm">
            {[
              ["Prestations", "/#services"],
              ["Avis Google", "/#reviews"],
              ["Bio", "/#bio"],
              ["Série YouTube", "/#serie"],
              ["Galerie", "/#galerie"],
              ["Univers", "/#universe"],
              ["Contact", "/#contact"],
            ].map(([label, href]) => (
              <li key={href}>
                <a
                  href={href}
                  className="text-zinc-300 hover:text-[#D4AF37] transition-colors"
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs uppercase tracking-[0.22em] text-zinc-500 mb-4">
            Contact
          </div>
          <ul className="space-y-3 text-sm">
            <li>
              <a
                href={`tel:${SITE.phoneInternational}`}
                data-testid="footer-phone"
                className="text-zinc-200 hover:text-[#D4AF37]"
              >
                {SITE.phoneDisplay}
              </a>
            </li>
            <li>
              <a
                href={`mailto:${SITE.email}`}
                data-testid="footer-email"
                className="text-zinc-200 hover:text-[#D4AF37]"
              >
                {SITE.email}
              </a>
            </li>
            <li>
              <a
                href={`https://${SITE.website}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-zinc-200 hover:text-[#D4AF37]"
              >
                {SITE.website}
              </a>
            </li>
          </ul>

          <div className="text-xs uppercase tracking-[0.22em] text-zinc-500 mt-7 mb-4">
            Réseaux
          </div>
          <div className="flex flex-wrap gap-3">
            {[
              ["TikTok", SITE.socials.tiktok],
              ["Instagram", SITE.socials.instagram],
              ["Facebook", SITE.socials.facebook],
              ["YouTube", SITE.socials.youtube],
              ["LinkedIn", SITE.socials.linkedin],
              ["SoundCloud", SITE.socials.soundcloud],
            ].map(([name, url]) => (
              <a
                key={name}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`footer-social-${name.toLowerCase()}`}
                className="text-xs px-3 py-2 rounded-full border border-white/10 bg-white/[0.02] text-zinc-300 hover:text-[#D4AF37] hover:border-[#D4AF37]/30 transition"
              >
                {name}
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-14 pt-6 border-t border-white/5 flex flex-col md:flex-row justify-between gap-4 text-xs text-zinc-500">
        <div>
          © {new Date().getFullYear()} DJ AS Animation – Adrien Sebert. Tous droits réservés.
        </div>
        <div className="flex gap-5">
          <Link to="/mentions-legales" data-testid="footer-legal-link" className="hover:text-[#D4AF37]">Mentions légales</Link>
          <Link to="/confidentialite" data-testid="footer-privacy-link" className="hover:text-[#D4AF37]">Politique de confidentialité</Link>
        </div>
      </div>
    </footer>
  );
};
